export default "__VITE_ASSET__tZ1e$eLH__"